import { ButtonFramelessProps } from './types'
import { Button } from 'components/Button'

/**
 * @deprecated ButtonFrameless was absorbed into the canonical `components/Button`
 * as `variant="text"`. This is now a thin adapter that forwards its props onto
 * `<Button variant="text" />` (whose text branch renders the frameless CSS
 * verbatim — state paints theme-bound — so existing call sites stay
 * pearl-theme-identical). Do not add new
 * imports — use `<Button variant="text" … />` from components/Button directly.
 * Its props (`icon` / `iconRight` boolean / `stacked` / `whiteBg` / `size`) map
 * 1:1 onto the Button text-variant props.
 */
export const ButtonFrameless = ({
  // `color` is the dead HTMLAttributes string attr (never used by the frameless
  // button); drop it so it doesn't clash with Button's typed `color` palette.
  color: _color,
  ...props
}: ButtonFramelessProps) => <Button {...props} variant="text" />
